<template>
  <div class="meetingDetail">
    <h2 class="title">{{meetingDataOrigin.hylx}}</h2>
    <div v-if="meetingData" class="container">
      <table>
        <tr v-for="item in meetingData">
          <td class="desc">{{item.desc}}</td>
          <td class="value">{{item.value}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import apiConfig from 'common/js/api_config'
  import {mapState} from 'vuex'

  export default {
    name: "meeting",
    data() {
      return {
        meetingDataOrigin:{},
        meetingData:[]
      }
    },
    props:{
      meetingId:{
        type:String,
        default:''
      }
    },
    computed: {
      ...mapState(['meetingColumnDesc'])
    },
    methods: {
      async _initMeeting(){
        let meetingData=await axios.post(apiConfig.REQUEST_URL+'/shall/front_getMeeting?ids=' + this.meetingId)
        this.meetingDataOrigin=meetingData.data.data[0]
        this.meetingData=this._formatData(meetingData.data.data[0])
      },
      _formatData(data){
        let ret=[]
        for (let key in data){
          if(data[key]){
            ret.unshift({
              desc:this._getKeyDesc(key.toUpperCase()),
              key:key,
              value:data[key]
            })
          }
        }
        return ret
      },
      _getKeyDesc(key){
        if(this.meetingColumnDesc[key]){
          return this.meetingColumnDesc[key]
        }
        return 0
      }
    },
    mounted() {
      this._initMeeting()
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
.meetingDetail
  &>.title
    text-align center
    line-height 60px
    font-size 18px
    color #666666
    margin-top 20px
  .container
    table
      width 100%
      margin auto
      margin-top 20px
      tr
        transition 300ms
        &:hover
          background-color #f1f1f1
        td
          border 1px solid #eeeeee
          line-height 40px
          color #666666
          font-size 14px
          vertical-align middle
          &.desc
            width 260px
            text-align center
          &.value
            padding-left 40px
            border 1px solid #eeeeee
</style>



// WEBPACK FOOTER //
// src/components/meeting/meetingDetail.vue